var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconexit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_exit",
    "data-name": "icon exit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.546,
    height: 14.546,
    viewBox: "0 0 14.546 14.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3307",
    "data-name": "Groupe 3307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11487",
    "data-name": "Trac\\xE9 11487",
    d: "M17.25,2.571H.75C.338,2.571,0,1.993,0,1.286H0C0,.579.338,0,.75,0h16.5c.413,0,.75.579.75,1.286h0C18,1.993,17.663,2.571,17.25,2.571Z",
    transform: "translate(1.818 0) rotate(45)",
    fill: "#daab3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11488",
    "data-name": "Trac\\xE9 11488",
    d: "M17.25,2.571H.75C.338,2.571,0,1.993,0,1.286H0C0,.579.338,0,.75,0h16.5c.413,0,.75.579.75,1.286h0C18,1.993,17.663,2.571,17.25,2.571Z",
    transform: "translate(0 12.728) rotate(-45)",
    fill: "#daab3a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconexit);
export default __webpack_public_path__ + "static/media/icon exit.4ea07d50ed5806961e2407fe444ad327.svg";
export { ForwardRef as ReactComponent };